<template>
  <div>
    <div class="py-2 text-general">
      <div class="p-2 d-flex justify-content-between">
        <label class="header-text text-main"
          >รายละเอียดรายการแลกของรางวัล</label
        >
      </div>
      <div class="p-3">
        <div class="d-flex mb-2">
          <div>
            <img :src="form.imge" alt="product" width="50" class="mr-2" />
          </div>
          <div>
            <div class="text-gray-2 text-wrap-customs">
              {{ form.gift }}
            </div>
            <div class="text-gray-2 text-wrap-customs">
              ({{ form.redeem_name }})
            </div>
          </div>
        </div>
        <div class="row align-items-center">
          <div class="col-6 font-weight-bold">วันที่แลกของ</div>
          <div class="col-6 text-right text-gray-2">
            {{ form.redeem_date | moment("DD MMM YYYY (HH:mm)") }}
          </div>
          <div class="col-6 font-weight-bold">Member ID</div>
          <div class="col-6 text-right text-gray-2">{{ form.member_id }}</div>
          <div class="col-6 font-weight-bold">ชื่อ</div>
          <div class="col-6 text-right text-gray-2">
            {{ form.first_name_th || "-" }} {{ form.last_name_th }}
          </div>
          <div class="col-6 font-weight-bold">เบอร์โทรศัพท์</div>
          <div class="col-6 text-right text-gray-2">{{ form.telephone }}</div>
          <div class="col-6 font-weight-bold">คะแนนที่ใช้แลก</div>
          <div class="col-6 text-right text-gray-2">
            {{ form.used_point | numeral("0,0") }} คะแนน
          </div>
          <div class="col-6 font-weight-bold">สาขาที่แลก</div>
          <div class="col-6 text-right text-gray-2">{{ form.branch_name }}</div>
          <div class="col-6 font-weight-bold">สถานะ</div>
          <div class="col-6 text-right text-gray-2">{{ form.status_name }}</div>
        </div>
      </div>
      <div class="footer-page p-2">
        <b-button
          class="radius-btn bg-main"
          block
          :disabled="isLoading || form.status != 3"
          @click="confirmRedeem"
          >ยืนยันรับของ
        </b-button>
        <b-button
          v-if="form.cancel_valid === 1"
          class="radius-btn btn-link"
          block
          :disabled="isLoading"
          @click="confirmCancel"
          >ยกเลิกรับของ
        </b-button>
        <b-row no-gutters>
          <b-col cols="6" class="pr-1">
            <b-button
              class="radius-btn btn-link"
              block
              :disabled="isLoading"
              :to="`/redeem/history/${form.member_id}`"
              >ย้อนกลับ
            </b-button>
          </b-col>
          <b-col cols="6" class="pl-1">
            <b-button
              class="radius-btn btn-link"
              block
              :disabled="isLoading"
              @click="handleAddNote"
              >เพิ่มบันทึก
            </b-button>
          </b-col>
        </b-row>
      </div>
      <ModalLoading ref="modalLoading" :hasClose="false" />
      <ModalAddNote
        :form="formAddNote"
        ref="modalAddNote"
        @confirm="confirmAddNote"
      />
      <ModalOTP ref="modalOTP" @confirm="confirmAddNote" />
    </div>
  </div>
</template>

<script>
import ModalLoading from "@/components/modal/alert/ModalLoading";
import ModalAddNote from "./components/ModalAddNote.vue";
import ModalOTP from "./components/ModalOTP.vue";
import { mapGetters } from "vuex";

export default {
  name: "ReportIndex",
  components: {
    ModalLoading,
    ModalAddNote,
    ModalOTP,
  },
  computed: {
    ...mapGetters({ selectedItem: "getSelectedItem" }),
  },
  data() {
    return {
      isLoading: false,
      id: this.$route.params.id,
      form: {},
      formAddNote: {
        note: "",
      },
      resOTP: {},
    };
  },
  async created() {
    this.id = this.$route.params.id;
    if (!this.selectedItem)
      this.$router.push({ path: `/redeem` }).catch(() => {});

    this.form = { ...this.selectedItem };
  },
  methods: {
    async handleAddNote() {
      await this.axios
        .get(`${this.$baseUrl}/redeem/get_note/${this.form.user_guid}`)
        .then((data) => {
          if (data.result == 1) {
            this.formAddNote.note = data.note;
          }
        });

      await this.$refs.modalAddNote.show();
    },
    async confirmAddNote() {
      let body = {
        user_guid: this.form.user_guid,
        note: this.formAddNote.note,
      };
      await this.axios
        .post(`${this.$baseUrl}/redeem/update_note`, body)
        .then(async (data) => {
          if (data.result == 1) {
            this.successAlert();
            this.$refs.modalAddNote.hide();
          } else {
            this.warningAlert(data.message);
          }
        })
        .catch((err) => {
          this.warningAlert(err.message);
        });
    },
    async confirmRedeem() {
      this.$refs.modalOTP.show();
    },
    async confirmCancel() {
      let body = {
        new_status: 6,
        redeem_order_id: this.selectedItem.redeem_order_id,
      };
      await this.axios
        .post(`${this.$baseUrl}/redeem/update_redeem_order_status`, body)
        .then(async (data) => {
          if (data.result == 1) {
            this.disabled = true;
            this.successAlert();
            this.$router
              .push({ path: `/redeem/history/${this.selectedItem.member_id}` })
              .catch(() => {});
          } else {
            this.warningAlert(data.message);
          }
        })
        .catch((err) => {
          this.warningAlert(err.message);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.filter-slide-btn {
  background-color: #e8e9ec;
  border: none;
}
.link-to {
  text-decoration: underline;
  color: #7c7a7a;
}
.text-main {
  color: var(--primary-color) !important;
}
.btn-link {
  border-color: var(--primary-color) !important;
  background-color: transparent !important;
  color: var(--primary-color) !important;
  margin-top: 0.5rem;
}
.footer-page {
  width: 100%;
  position: fixed;
  bottom: 60px;
  left: 0;
}
.text-wrap-customs {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.5em;
  height: 1.5em;
}
</style>
